export function normalizeAuthRedirectPath(
  value: string | null | undefined,
  fallback = "/",
) {
  const trimmed = value?.trim();
  if (!trimmed || !trimmed.startsWith("/") || trimmed.startsWith("//")) {
    return fallback;
  }
  return trimmed;
}
